export const contact = {
  contactHero: {
    title: 'INQUIRY',
    subtitle: '事務局へのご照会',
    description1: '組織の変革、あるいはご自身の構造的な成長に関するご相談を承ります。',
    description2: '世界中からのアクセスに対応するため、原則として3営業日（JST）以内に事務局よりご返信申し上げます。',
  },
  form: {
    title: 'お問い合わせフォーム',
    name: 'お名前',
    namePlaceholder: 'お名前を入力してください',
    email: 'メールアドレス',
    emailPlaceholder: 'your@email.com',
    organization: '組織・所属',
    organizationPlaceholder: '企業名または教育機関名',
    departmentTitle: '部署・役職名',
    departmentTitlePlaceholder: '例：営業部、マネージャー',
    inquiryType: 'お問い合わせ種別',
    selectPlaceholder: '選択してください',
    inquiryTypes: {
      individual: '個人プログラムのご照会',
      corporate: '企業研修',
      educational: '教育機関への導入',
      seminar: 'セミナー・ワークショップ',
      other: 'その他',
    },
    message: 'メッセージ',
    messagePlaceholder: 'お問い合わせ内容を詳しくご記入ください',
    submit: '送信する',
    submitting: '送信中...',
    success: 'お問い合わせを受け付けました。3営業日以内にご連絡いたします。',
    error: '送信中にエラーが発生しました。再度お試しください。',
    charCount: '{{count}} / 500文字',
    gratitudeMessage1: '私たちの理念に共鳴し、この場所へ辿り着いていただいたことに、深く感謝申し上げます。教育と構造が導く新たな未来へ、ここから共に歩み出せることを心待ちにしております。',
    gratitudeMessage2: '"We extend our deepest gratitude for your resonance with our philosophy. We look forward to embarking on a journey toward a newly structured future together."',
  },
};